var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    id: "svg862",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs866"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,22 V 18.3333 H 33 V 22 Z M 0,12.8333 V 9.16667 H 33 V 12.8333 Z M 0,3.66667 V 0 h 33 v 3.66667 z",
    fill: "#fef7ff",
    id: "path860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsWhite);
export default __webpack_public_path__ + "static/media/bars-white.4e80ea0689623c6639889b96038a73a0.svg";
export { ForwardRef as ReactComponent };